<template>
  <div>
    <nav-bar/>
    <div class="pt-4 mx-3">

      <div class="card">
        <div class="card-header">
          <h3 class="my-2"> {{$t('Reports.title')}}</h3>
        </div>
        <div class="card-block">
          <div class="row">
            <regular-input
            :value="search.from"
            @input="search.from = $event"
            type="date" placeholder="Date min" class="col-12 col-sm-6 col-lg-4 form-group"/>
            <regular-input
            :value="search.to"
            @input="search.to = $event"
            type="date" placeholder="Date max" class="col-12 col-sm-6 col-lg-4 form-group"/>
            <regular-datalist-driver
            :value="search.driver"
            @input="search.driver = $event.value; search.driverUid = $event.key"
            :secondList="liste"
            :placeholder="$t('OrderInfo.modal.driver')" class="col-12 col-sm-6 col-lg-4 form-group"/>
            <div class="col-6">
              <button class="btn btn-kne-orange w-100" @click="clear()">
                {{$t('Search.clear')}}
              </button>
            </div>
            <div class="col-6">
              <button class="btn btn-kne-orange w-100" :disabled="!filled" @click="submitSearch()">
                {{$t('Search.submit')}}
              </button>
            </div>
          </div>
        </div>
        <paginate-links @change="setLastPage" for="orders" :hide-single-page="true" :limit="5"></paginate-links>
        <paginate ref="paginator" name="orders" tag="div" :list="orders.deliveries" class="" :per="30">
        <div v-if="orders.deliveries.length > 0" class="table-responsive">
          <table class="table table-hover font-grey mb-0 table-sm">
            <thead class="bg-darkgrey">
              <tr>
                <th @click="sortBy('orderNb', false)" class="sortable nowrap">{{$t('OrderCurrent.order')}}<i v-if="sort.current === 'orderNb'" class="ml-1 fa" :class="{'fa-arrow-down': sort.desc, 'fa-arrow-up': !sort.desc}" aria-hidden="true"></i></th>
                <th @click="sortBy('reference', false)" class="sortable nowrap">{{$t('OrderCurrent.reference')}}<i v-if="sort.current === 'reference'" class="ml-1 fa" :class="{'fa-arrow-down': sort.desc, 'fa-arrow-up': !sort.desc}" aria-hidden="true"></i></th>
                <th @click="sortBy('source', false)" class="sortable nowrap">{{$t('OrderCurrent.source')}}<i v-if="sort.current === 'source'" class="ml-1 fa" :class="{'fa-arrow-down': sort.desc, 'fa-arrow-up': !sort.desc}" aria-hidden="true"></i></th>
                <th @click="sortBy('vin', false)" class="sortable nowrap">{{$t('OrderCurrent.VIN')}}<i v-if="sort.current === 'vin'" class="ml-1 fa" :class="{'fa-arrow-down': sort.desc, 'fa-arrow-up': !sort.desc}" aria-hidden="true"></i></th>
                <th @click="sortBy('date', false)" class="sortable nowrap">{{$t('OrderCurrent.date')}}<i v-if="sort.current === 'date'" class="ml-1 fa" :class="{'fa-arrow-down': sort.desc, 'fa-arrow-up': !sort.desc}" aria-hidden="true"></i></th>
                <th @click="sortBy('pickup', false)" class="sortable nowrap">{{$t('OrderCurrent.pickup')}}<i v-if="sort.current === 'pickup'" class="ml-1 fa" :class="{'fa-arrow-down': sort.desc, 'fa-arrow-up': !sort.desc}" aria-hidden="true"></i></th>
                <th @click="sortBy('delivery', false)" class="sortable nowrap">{{$t('OrderCurrent.delivery')}}<i v-if="sort.current === 'delivery'" class="ml-1 fa" :class="{'fa-arrow-down': sort.desc, 'fa-arrow-up': !sort.desc}" aria-hidden="true"></i></th>
                <th @click="sortBy('billing', false)" class="sortable nowrap">{{$t('OrderCurrent.billing')}}<i v-if="sort.current === 'billing'" class="ml-1 fa" :class="{'fa-arrow-down': sort.desc, 'fa-arrow-up': !sort.desc}" aria-hidden="true"></i></th>
                <th @click="sortBy('status', false)" class="sortable nowrap">{{$t('OrderCurrent.status')}}<i v-if="sort.current === 'status'" class="ml-1 fa" :class="{'fa-arrow-down': sort.desc, 'fa-arrow-up': !sort.desc}" aria-hidden="true"></i></th>
                <th @click="sortBy('driver', false)" class="sortable nowrap">{{$t('OrderCurrent.driver')}}<i v-if="sort.current === 'driver'" class="ml-1 fa" :class="{'fa-arrow-down': sort.desc, 'fa-arrow-up': !sort.desc}" aria-hidden="true"></i></th>
                <th></th>
              </tr>
            </thead>
            <transition-group name="fade" tag="tbody">
              <tr v-for="order in paginated('orders')" :key="order.orderNb" :class="{'drop': order.status === 'Drop', 'cancel': order.status === 'Cancel', 'waiting': order.status === 'Attente', 'pick': order.status === 'Pick', 'transit': order.status === 'Transit', 'dispatch': order.status === 'Dispatch', 'reject': order.status === 'Reject', }">
                <td class="nowrap">{{order.orderNb}}</td>
                <th class="nowrap">{{order.reference}}</th>
                <td class="nowrap"><p class="table-fix-width">{{order.source}}</p></td>
                <td class="nowrap">{{order.vin}}</td>
                <th class="nowrap"><p class="table-fix-width">{{getDate(order.date)}}</p></th>
                <th class="nowrap"><p class="table-fix-width">{{order.pickup}}</p></th>
                <th class="nowrap"><p class="table-fix-width">{{order.delivery}}</p></th>
                <th class="nowrap"><p class="table-fix-width">{{order.billing}}</p></th>
                <th class="nowrap">
                  <span v-if="order.status === 'Dispatch'">{{$t('Search.status.dispatch')}}</span>
                  <span v-if="order.status === 'Processing'">{{$t('Search.status.processing')}}</span>
                  <span v-if="order.status === 'Pick'">{{$t('Search.status.pick')}}</span>
                  <span v-if="order.status === 'Attente'">{{$t('Search.status.waiting')}}</span>
                  <span v-if="order.status === 'Transit'">{{$t('Search.status.transit')}}</span>
                  <span v-if="order.status === 'Drop'">{{$t('Search.status.drop')}}</span>
                  <span v-if="order.status === 'Cancel'">{{$t('Search.status.canceled')}}</span>
                  <span v-if="order.status === 'Terminée'">{{$t('Search.status.finished')}}</span>
                  <span v-if="order.status === 'Transférée'">{{$t('Search.status.transfered')}}</span>
                  <span v-if="order.status === 'Reject'">{{$t('Search.status.rejected')}}</span>
                </th>
                <th class="nowrap"><p class="table-fix-width">{{order.driver}}</p></th>
                <td>
                  <a :href="'#/OrderInfo?orderId=' + order.orderNb">
                    <input type="button" class="btn btn-kne-orange pull-right" :value="$t('OrderCurrent.view')">
                  </a>
                </td>
              </tr>
            </transition-group>
          </table>
        </div>
        </paginate>
        <paginate-links @change="setLastPage" for="orders" :hide-single-page="true" :limit="5"></paginate-links>
      </div>
    </div>
  </div>
</template>

<script>
import regularInput from '../regularInput.vue'
import regularCheckbox from '../regularCheckbox.vue'
import regularTextarea from '../regularTextarea.vue'
import regularSelect from '../regularSelect.vue'
import regularDatalistDriver from '../regularDatalistDriver.vue'
import {db} from '../../firebase'

export default {
  name: 'Reports',
  components: {
    regularInput,
    regularCheckbox,
    regularTextarea,
    regularSelect,
    regularDatalistDriver
  },
  data () {
    return {
      orders: {
        deliveries: []
      },
      search: {
        from: '',
        to: '',
        driver: '',
        driverUid: ''
      },
      paginate: ['orders'],
      sort: {
        current: 'orderNb',
        desc: true
      }
    }
  },
  created () {
    if (this.$store.state.search !== null) {
      this.orders = JSON.parse(JSON.stringify(this.$store.state.search))
      this.search = JSON.parse(JSON.stringify(this.$store.state.searchFields))
    }
    this.$bindAsArray('liste', db.ref('database/transporter/' + this.companyUID + '/liste'))
  },
  methods: {
    setLastPage (toPage, fromPage) {
      this.$store.commit('SET_LAST_PAGE', toPage)
    },
    submitSearch () {
      var query = ''
      this.orders.deliveries = []
      if (this.search.from !== '') query = query + 'from=' + Date.parse(this.search.from) + '&'
      if (this.search.to !== '') query = query + 'to=' + Date.parse(this.search.to) + '&'
      if (this.search.driver !== '') query = query + 'driver=' + this.search.driver
      if (this.search.driverUid !== '') query = query + 'driverUid=' + this.search.driverUid
      if (query.slice(-1) === '&') query = query.slice(0, -1)
      window.axios.get('https://dev.transport.keepneye.com/infobemaster/decode/search/' + this.companyUID + '/' + query).then((response) => {
        this.$store.commit('SET_LAST_PAGE', 0)
        this.$store.commit('STORE_SEARCH', response.data)
        this.$store.commit('STORE_SEARCH_FIELD', this.search)
        this.orders = response.data
        this.orders.deliveries.reverse()
      }).catch((error) => console.log(error))
    },
    getDate (timestamp) {
      var date = new Date(timestamp)
      return date.toLocaleDateString() + ' ' + date.toLocaleTimeString('en-US', {timeZone: 'America/New_York'})
    },
    clear () {
      for (var attr in this.search) {
        this.search[attr] = ''
        this.orders.deliveries = []
        this.$store.commit('CLEAR_SEARCH')
      }
    },
    sortBy (criteria, newEntry) {
      if (this.sort.current === criteria && !newEntry) {
        this.sort.desc = !this.sort.desc
      } else if (!newEntry) {
        this.sort.desc = true
        this.sort.current = criteria
      }
      this.orders.deliveries.sort((a, b) => {
        if (a[criteria] === undefined) a[criteria] = ''
        if (b[criteria] === undefined) b[criteria] = ''
        var A = a[criteria]
        var B = b[criteria]
        if (criteria !== 'date') {
          A = a[criteria].toUpperCase() // ignore upper and lowercase
          B = b[criteria].toUpperCase() // ignore upper and lowercase
        }
        if (!this.sort.desc) {
          if (A < B) {
            return -1
          }
          if (A > B) {
            return 1
          }
        } else {
          if (A > B) {
            return -1
          }
          if (A < B) {
            return 1
          }
        }
        // names must be equal
        return 0
      })
    }
  },
  computed: {
    filled () {
      return this.search.from !== '' && this.search.to !== '' && this.search.driver !== '' && this.search.driverUid !== '' && this.search.driverUid !== null
    },
    companyUID () {
      return this.$store.state.authorization.company
    }
  },
  mounted () {
    if (this.$store.state.searchLastPage !== 0) this.$refs.paginator.goToPage(this.$store.state.searchLastPage)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.table thead th{
  border-bottom: 1px solid #eceeef;
  border-top: none;
}
input, button{
  cursor: pointer;
}
#addOrder{
  position: fixed;
  right: 1rem;
  bottom: 1rem;
}
</style>



// WEBPACK FOOTER //
// Reports.vue?58102f2b